module.exports = __webpack_public_path__ + "static/media/fieldclick.cc348519.mp3";